import React from 'react';
import { format } from 'date-fns';
import { Tooltip } from '@mui/material';
import { IDataTableColumn } from '../../dataTable/DataTable/model';
import MachineRowMenu from '../components/MachineRowMenu';
import AdminMachineRowMenu from '../../machinesAdminManagement/components/MachineRowMenu';
import { formatUTCToLocal, formatUTCToShortDate } from '../../utils/dateUtils';

const getColorByConnectionState = (state) => {
  switch (state) {
    case 'online':
      return 'green';
    case 'offline':
      return 'red';
    default:
      return 'black';
  }
};

const defaultUserMachineColumns: IDataTableColumn<any>[] = [
  {
    name: 'Machine Name',
    selector: 'machine_name',
    sortable: true,
  },
  {
    name: 'Machine Serial',
    selector: 'serial_number',
    sortable: true,
    sortFunction: (a: Record<string, string>, b: Record<string, string>): unknown => {
      const valA = parseFloat(a.serial_number) || 0;
      const valB = parseFloat(b.serial_number) || 0;
      return valA - valB;
    },
  },
  {
    name: 'Connection State',
    selector: 'connection_state',
    sortable: true,
    grow: 0.9,
    cell: ({ connection_state }): React.ReactNode => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 12,
          fontWeight: 500,
        }}
      >
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: connection_state === 'online' ? '#28a745' : '#dc3545',
            marginRight: 6,
          }}
        />
        <span style={{ color: connection_state === 'online' ? '#28a745' : '#dc3545' }}>
          {connection_state === 'online' ? 'Online' : 'Offline'}
        </span>
      </div>
    ),
  },
  {
    name: 'Last Online',
    selector: 'last_online_date',
    grow: 1.5,
    sortable: true,
    cell: (row): React.ReactNode => <div style={{ fontSize: 12 }}>{formatUTCToLocal(row?.last_online_date)}</div>,
  },
  {
    name: 'Last Offline',
    selector: 'last_offline_date',
    grow: 1.5,
    sortable: true,
    cell: (row): React.ReactNode => <div style={{ fontSize: 12 }}>{formatUTCToLocal(row?.last_offline_date)}</div>,
  },
  {
    name: 'System Version',
    selector: 'system_type',
    sortable: true,
  },
  {
    name: 'InduSoftProject',
    selector: 'indusoft_project',
    sortable: true,
  },
  {
    name: 'Subscription',
    selector: 'subscription_active',
    sortable: true,
    cell: ({ subscription_active }): React.ReactNode => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 12,
          fontWeight: 500,
        }}
      >
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: subscription_active ? '#007bff' : '#ff8800',
            marginRight: 6,
          }}
        />
        <span style={{ color: subscription_active ? '#007bff' : '#ff8800' }}>
          {subscription_active ? 'Active' : 'Inactive'}
        </span>
      </div>
    ),
  },
  {
    name: 'Expiration',
    selector: 'subscription_expiration_date',
    grow: 1.2,
    sortable: true,
    cell: (row): React.ReactNode => (
      <div style={{ fontSize: 12 }}>{formatUTCToShortDate(row?.subscription_expiration_date)}</div>
    ),
  },
];

export default defaultUserMachineColumns;
